module.exports = __webpack_public_path__ + "img/gallery-image--1.353f4315.png";